import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { environment } from './environments/environment';

async function prepareApp(): Promise<void> {
  if (environment.mockApi) {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    });
    console.info('[MSW] Mock API active — /api/* requests are intercepted');
  }
}

prepareApp().then(() => bootstrapApplication(AppComponent, appConfig));
